import { Accordion } from "@szhsin/react-accordion";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { RadioButton } from "ui";

import { STATUS_FILTER_SEARCH_PARAMETER } from "../../../../constants";
import { ProductStatusFilterValues } from "../../../../product.types";
import { FilterAccordion } from "../FilterAccordion";

import styles from "./StatusFilter.module.scss";

const StatusFilter = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedStatus = searchParams.get(STATUS_FILTER_SEARCH_PARAMETER);

  const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchParams.set(
      STATUS_FILTER_SEARCH_PARAMETER,
      String(e.currentTarget.value)
    );

    setSearchParams(searchParams);
  };

  const handleClearClick = () => {
    searchParams.set(
      STATUS_FILTER_SEARCH_PARAMETER,
      ProductStatusFilterValues.ALL
    );

    setSearchParams(searchParams);
  };

  return (
    <Accordion transition transitionTimeout={250}>
      <FilterAccordion
        header={t("Item Status")}
        isClearDisplay={
          !!selectedStatus && selectedStatus !== ProductStatusFilterValues.ALL
        }
        onClearClick={handleClearClick}
      >
        <div className={styles.optionsContainer}>
          <RadioButton
            checked={
              !selectedStatus ||
              selectedStatus === ProductStatusFilterValues.ALL
            }
            value={ProductStatusFilterValues.ALL}
            onChange={handleStatusChange}
            label={t("All")}
          />
          <RadioButton
            checked={selectedStatus === ProductStatusFilterValues.VERIFIED}
            value={ProductStatusFilterValues.VERIFIED}
            onChange={handleStatusChange}
            label={t("Verified")}
          />
          <RadioButton
            checked={selectedStatus === ProductStatusFilterValues.NOT_VEREFIED}
            value={ProductStatusFilterValues.NOT_VEREFIED}
            onChange={handleStatusChange}
            label={t("Not Verified")}
          />
        </div>
      </FilterAccordion>
    </Accordion>
  );
};

export default StatusFilter;
